"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var styled_1 = __importDefault(require("../../styled"));
var button_1 = __importDefault(require("../../atoms/button"));
var heading_1 = require("../../atoms/heading");
var button_group_1 = __importDefault(require("../../molecules/button-group"));
var tabs_1 = __importDefault(require("../../molecules/tabs"));
var _overlay_1 = __importDefault(require("../../atoms/_overlay"));
var dialog_action_1 = __importDefault(require("./dialog-action"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var root_props_1 = require("../../_helpers/root-props");
var createButtonForAction = function (action, index) {
    if (!(action instanceof dialog_action_1.default)) {
        if (action.type !== button_1.default) {
            throw new Error('Invalid action component passed to Dialog.');
        }
        return React.cloneElement(action, __assign({ key: index }, automation_attribute_1.default('dialog.action')));
    }
    var buttonProps = {
        onClick: action.handler,
        appearance: action.appearance
    };
    return (React.createElement(button_1.default, __assign({ key: index }, buttonProps, automation_attribute_1.default('dialog.action')), action.label));
};
var focusOnFormInput = function (_a) {
    var current = _a.current;
    var node = ReactDOM.findDOMNode(current);
    if (!node) {
        return;
    }
    var form = node.querySelector('form');
    if (!form) {
        return;
    }
    var firstInput = form.querySelector('input');
    if (!firstInput) {
        return;
    }
    firstInput.focus();
};
var getAccessibilityRole = function (props, requiredRole, propObject) {
    return props.role === requiredRole ? propObject : {};
};
var DialogBox = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  pointer-events: auto;\n  position: relative;\n  max-height: calc(100vh - (", " * 2));\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: 3px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n"], ["\n  ", ";\n  pointer-events: auto;\n  position: relative;\n  max-height: calc(100vh - (", " * 2));\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: 3px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n"])), container_styles_1.default, tokens_1.spacing.xlarge, tokens_1.colors.base.white);
var DialogClose = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  /* Overwirtes the color of the icons */\n  ", " {\n    &,\n    i,\n    svg,\n    path {\n      color: ", ";\n      fill: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  /* Overwirtes the color of the icons */\n  ", " {\n    &,\n    i,\n    svg,\n    path {\n      color: ", ";\n      fill: ", ";\n    }\n  }\n"])), button_1.default.Element, tokens_1.colors.base.black, tokens_1.colors.base.black);
var DialogHeader = styled_1.default.header(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  padding: ", " ", " ", " ", ";\n  color: ", ";\n  word-break: break-word;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  text-align: center;\n"], ["\n  position: relative;\n  padding: ", " ", " ", " ", ";\n  color: ", ";\n  word-break: break-word;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  text-align: center;\n"])), tokens_1.spacing.small, tokens_1.spacing.large, tokens_1.spacing.xsmall, tokens_1.spacing.large, tokens_1.colors.text.default);
var DialogTitle = function (props) {
    var InternalTitle = styled_1.default(heading_1.BaseHeading.withComponent(props.element))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: ", ";\n    font-size: ", ";\n    margin: 0;\n  "], ["\n    font-weight: ", ";\n    font-size: ", ";\n    margin: 0;\n  "])), tokens_1.fonts.weight.medium, tokens_1.fonts.size.default);
    return React.createElement(InternalTitle, __assign({}, props));
};
var DialogBody = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", " ", " ", " ", ";\n  flex: 1 1 auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  word-break: break-word;\n  word-wrap: break-word;\n  /* Clears the margin of the last item of the body */\n  > *:last-child {\n    margin-bottom: 0;\n  }\n\n  ", " {\n    margin-top: -", ";\n    margin-left: -", ";\n    margin-right: -", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    justify-content: center;\n  }\n"], ["\n  padding: ", " ", " ", " ", ";\n  flex: 1 1 auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  word-break: break-word;\n  word-wrap: break-word;\n  /* Clears the margin of the last item of the body */\n  > *:last-child {\n    margin-bottom: 0;\n  }\n\n  ", " {\n    margin-top: -", ";\n    margin-left: -", ";\n    margin-right: -", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    justify-content: center;\n  }\n"])), tokens_1.spacing.small, tokens_1.spacing.medium, tokens_1.spacing.large, tokens_1.spacing.medium, tabs_1.default.TabList, tokens_1.spacing.small, tokens_1.spacing.medium, tokens_1.spacing.medium, tokens_1.spacing.medium, tokens_1.spacing.medium);
var DialogFooter = styled_1.default.footer(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  padding: ", ";\n  border-top: 1px solid ", ";\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  padding: ", ";\n  border-top: 1px solid ", ";\n"])), tokens_1.spacing.small, tokens_1.colors.base.grayLight);
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childrenRef = React.createRef();
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.role === 'form') {
            setImmediate(function () { return focusOnFormInput(_this.childrenRef); });
        }
    };
    Dialog.prototype.render = function () {
        var props = this.props;
        return (React.createElement(_overlay_1.default, __assign({ contentSize: props.width }, props),
            React.createElement(react_focus_lock_1.default, { persistentFocus: false },
                React.createElement(DialogBox, __assign({ width: props.width }, automation_attribute_1.default('dialog'), getAccessibilityRole(props, 'destructive', {
                    'aria-describedby': 'dialog-description'
                }), { role: "dialog", "aria-modal": "true", "aria-labelledby": "dialog-title" }, root_props_1.rootProps(props)),
                    React.createElement(DialogClose, null,
                        React.createElement(button_1.default, __assign({ "aria-label": "Close", size: "default", appearance: "link", icon: "close", onClick: props.onClose }, automation_attribute_1.default('dialog.close')))),
                    props.title && (React.createElement(DialogHeader, __assign({}, automation_attribute_1.default('dialog.title')),
                        React.createElement(DialogTitle, { element: props.titleElement, id: "dialog-title" }, props.title))),
                    React.createElement(DialogBody, __assign({ ref: this.childrenRef, id: "dialog-description" }, automation_attribute_1.default('dialog.body')), props.children),
                    props.actions && props.actions.length > 0 && (React.createElement(DialogFooter, __assign({}, automation_attribute_1.default('dialog.footer')),
                        React.createElement(button_group_1.default, null, props.actions.map(createButtonForAction))))))));
    };
    Dialog.Action = dialog_action_1.default;
    Dialog.Element = DialogBox;
    Dialog.defaultProps = {
        width: 'medium',
        role: 'default',
        actions: [],
        titleElement: 'h2'
    };
    return Dialog;
}(React.Component));
exports.default = Dialog;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=dialog.js.map